import React, { useEffect } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";

import { GET_ME } from "graphql/query/user-gql";
import {
    getAttachmentIdFromPath,
    isAttachmentAuthenticationError,
    redirectAttachmentToLogin,
} from "utils/attachment-auth";

import { WrapColumn } from "../wraps";
import { MainRoutes } from "../routes";
import { Header, MainBarMobile } from "../menu-bar";
import { ElementVisibility } from "../service";
import { ErrorBlock, Loader } from "../result";

import './app-colors.css';
import './app.css';


const App = () => {

    const { loading, error, client } = useQuery(GET_ME);
    const history = useHistory();
    const location = useLocation();
    const attachmentId = getAttachmentIdFromPath(location.pathname);
    const attachmentAuthError = attachmentId !== null && isAttachmentAuthenticationError(error);

    useEffect(() => {
        if (attachmentAuthError) {
            // The helper always clears auth and redirects, including a rejected cache reset.
            redirectAttachmentToLogin(client, history, attachmentId).catch(() => {});
        }
    }, [attachmentAuthError, attachmentId, client, history]);

    if (attachmentAuthError) {
        return <Loader type="block" />;
    }

    return (
        <>
            { loading &&
                <Loader type="block" />
            }
            { !loading && !error &&
                <>
                    <ElementVisibility maxWidth={768} type="toggle" comparison="<">
                        <WrapColumn position="show">
                            <MainBarMobile/>
                        </WrapColumn>
                        <WrapColumn position="hide">
                            <Header/>
                        </WrapColumn>
                    </ElementVisibility>
                    <main className="main-block">
                        <MainRoutes/>
                    </main>
                </>
            }
            { error &&
                <ErrorBlock
                    action={
                        () => {
                            localStorage.clear();
                            client.resetStore();
                            history.push("/");
                        }
                    }
                />
            }
        </>
    );
};

export default App;
